import React, { Component } from 'react';
import DocumentUploader from '../dropzone';
import ViewUploadedFiles from '../ViewUploadeFiles';
import { inject, observer } from 'mobx-react';

@inject('businessProfileStore')
@observer
class BalanceSheetPage extends Component {
  handleRemoveDocument = (e, documentId) => {
    const { businessFinancials } = this.props.businessProfileStore.businessProfile;
    if (businessFinancials && businessFinancials.annualBalanceSheetDocs) {
      const updatedDocs = businessFinancials.annualBalanceSheetDocs.filter(
        document => document.id !== documentId
      );
      this.props.businessProfileStore.businessProfile.businessFinancials.annualBalanceSheetDocs = updatedDocs;
    }
  };

  render() {
    const { businessProfile } = this.props.businessProfileStore;
    const businessFinancials = businessProfile.businessFinancials || {};
    const annualBalanceSheetDocs = businessFinancials.annualBalanceSheetDocs || [];
    const id = businessFinancials._id || businessFinancials.id;

    const MAX_DOCUMENTS = 2;
    const totalDocuments = annualBalanceSheetDocs.length;
    const remainingSlots = MAX_DOCUMENTS - totalDocuments;

    let fileInfo = {};
    if (id) {
      fileInfo = {
        files: [],
        path: '/public/upload',
        refId: id,
        ref: 'businessfinancials',
        source: 'content-manager',
        field: 'annualBalanceSheetDocs'
      };
    }

    return (
      <section className="p-h-15 p-v-20">
        {/* <h5 className="mb-3">Upload Latest 6 Months Management Accounts</h5> */}
        {remainingSlots > 0 && id && (
          <DocumentUploader
            fileData={fileInfo}
            maxFiles={remainingSlots}
            multiple={true}
            inputContent={'Upload Latest 6 Months Management Accounts'}
          />
        )}
        <div className="row justify-content-center mt-2">
          {annualBalanceSheetDocs.length > 0 && (
            <ViewUploadedFiles
              title="Uploaded Documents"
              data={annualBalanceSheetDocs}
              handleRemoveDocument={this.handleRemoveDocument}
            />
          )}
        </div>
      </section>
    );
  }
}
export default BalanceSheetPage;
